<template>
  <div :class="$style.AllocationTimes">
    {{ row.allocation_count }}
    <span :class="$style.m2">/</span>
    <SpanEdit v-model="row.times_set"
      type="number"
      :inputProps="{
        controlsPosition: 'right',
        min: 0,
        step: 1,
        stepStrictly: true,
        controls: false,
      }"
      :beforeSubmit="beforeSubmit"
      :disabled="disabled"
      @submit="onSubmit"
    />
    
  </div>
</template>

<script>
import SpanEdit from '@/components/SpanEdit.vue'
import { listNameModify } from './api'
export default {
  components: { SpanEdit },
  props: {
    row: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    beforeSubmit (val) {
      if (val < this.row.allocation_count) {
        this.$message.error('计划分配客户数不得小于当前已分配的客户数')
        return false
      }
      return true
    },
    async onSubmit (val, oldVal) {
      try {
        let { code, msg } = await listNameModify({
          id: this.row.id,
          times_set: val
        })
        if (code !== 200) {
          throw new Error(msg)
        }
        this.$message.success('修改成功')
      } catch (e) {
        this.row.times_set = oldVal
        this.$message.error(e.message || e)
      }
    },
  }
}
</script>

<style lang="scss" module>
.AllocationTimes {
  display: flex;
  align-items:center;
  justify-content: center;
}
.m2 {
  margin: 0 2px;
}
</style>